import { ServiceLayoutColumn } from '@common/data-models/service/service-layout-column';

export class ServiceLayout {

    public DefaultLayout: Array<ServiceLayoutColumn>;
    public DefaultLayoutType: number;

    public static instance(data: any, type: number): ServiceLayout {
        const ret = new ServiceLayout();
        ret.DefaultLayout = data;
        ret.DefaultLayoutType = type;
        return ret;
    }

}
